import {Pipe, PipeTransform} from '@angular/core';
import {LOGIN_SUFFIX} from '../translate.suffix';
import {TranslateService} from '../services/translate.service';
import {Observable} from 'rxjs';

@Pipe({
  name: 'cpLoginTranslate',
  pure: true
})
export class LoginTranslatePipe implements PipeTransform {
  constructor(private translateService: TranslateService) { }

  transform(query: string, args: any[] = []): Observable<string> {
    return this.translateService.transformLogin(
      this.translateService.containsRegisteredTranslateSuffix(query) ? query : query + LOGIN_SUFFIX, ...args);
  }
}
